import React, { useRef,useContext,useState } from "react";

import { ContextEngine } from "../../engine/ContextEngine";
import { EventsRegistry } from "../../engine/events/index";
import {triggerEvent} from "../../engine/events/bus";
import CentralControlsBar from "./CentralControlsBar";
import DynamicTable from "./CentralUnitViewPort/DynamicTable";
// import MantineTable from "./CentralUnitViewPort/MantineTable";
// import IfcTubePage from "./CentralUnitViewPort/ifctube-app/pages/IfcTubePage";

import "./Central1.css";

const Central = () => {
  const topPanelRef = useRef(null); // Create ref for top panel
  const { context, updateContext } = useContext(ContextEngine);  
  const [topPanelHeight, setTopPanelHeight] = useState(context.view.topControl || 200);

  const handleDrop = (file) => {
    const fileData = {
      file,
      name: file.name,
      size: file.size,
      type: file.type,
      source: "central-panel",
      ts: Date.now(),
    };
    alert("File dropped:", fileData);

    triggerEvent(EventsRegistry.FILE_DROPPED, fileData)
  };

  const unitIndex = context.context_units.findIndex(u => u.type === "table");
  if (unitIndex === -1) return <div>No central unit</div>;  

  const centralUnit = context.context_units[unitIndex];

const handleHorizontalDrag = (e) => {
  e.preventDefault();
  const startY = e.clientY; // Starting Y coordinate of the drag
  const startTopHeight = topPanelHeight;

  const onMove = (moveEvent) => {
    // Calculate the new height based on the drag
    const newHeight = startTopHeight + (moveEvent.clientY - startY);

    // Ensure that the height does not go below 100px
    const constrainedHeight = Math.max(50, newHeight);
    setTopPanelHeight(constrainedHeight);

    updateContext("view.topControl", constrainedHeight)
    // Manipulate the height directly using the ref if needed
    if (topPanelRef.current) {
      topPanelRef.current.style.height = `${constrainedHeight}px`;
    }
  };

  const onUp = () => {
    window.removeEventListener("mousemove", onMove);
    window.removeEventListener("mouseup", onUp);
  };

  window.addEventListener("mousemove", onMove);
  window.addEventListener("mouseup", onUp);
};


  return (
    <div className="central-root" >
      {/* Top strip: controls */}

      <div className="central-controls-strip"
        ref={topPanelRef} // Attach the ref to the div
        style={{ height: `${topPanelHeight}px` }} // Dynamically set the height
      >        
      <CentralControlsBar />
      </div>
      {/* <IfcTubePage /> */}
      <div
        className="divider-horizontal"
        onMouseDown={handleHorizontalDrag} // Start dragging
      ></div>
      {/* Main viewport: unit */}
      <div className="central-unit-viewport"
            onDrop={(e) => {
              e.preventDefault();
              handleDrop(e.dataTransfer.files[0]);
            }}
            onDragOver={(e) => e.preventDefault()}
      >
        <DynamicTable centralUnit={centralUnit} onUnitChange={null} />
      </div>
    </div>
  );
};

export default Central;
